import * as React from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import { EmployeeBlocksEmployeeFragment } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'
import { useAsyncCan } from 'modules/core/lib/useAsyncCan'

import type { CompanyInstallations } from 'modules/marketplace/store/collections/companyInstallations'
import Code, { CodeHandle } from 'modules/payroll_integrations/components/Employee/Code'
import integrationsDescriptor from 'modules/payroll_integrations/components/IntegrationsDescriptor'
import PayrollIntegration from 'modules/payroll_integrations/lib/catalog'

interface Props {
  employee: EmployeeBlocksEmployeeFragment
  readonly?: boolean
  onChange: () => void
  installedIntegrations: CompanyInstallations
  codeRef: React.MutableRefObject<Array<CodeHandle | null>>
}

const Codes = (props: Props) => {
  const { employee, readonly, onChange, codeRef, installedIntegrations } = props

  const ManageCodes = (): boolean => {
    const { value: canManageCodes, loading: loadingPermissions } = useAsyncCan(
      'payroll_integrations_codes.manage'
    )

    return !loadingPermissions && canManageCodes
  }

  const label = (name: string): string => {
    // these options should match with the AVAILABLE_INTEGRATIONS in IntegrationDescriptor
    switch (name) {
      case PayrollIntegration.a3nom:
        return i18n.t('employee_form.payroll_integrations.a3nom.label')
      case PayrollIntegration.a3innuva:
        return i18n.t('employee_form.payroll_integrations.a3innuva.label')
      case PayrollIntegration.datevApi:
      case PayrollIntegration.datevLugApi:
      case PayrollIntegration.datevLauds:
        return i18n.t('employee_form.payroll_integrations.datev_api.label')
      case PayrollIntegration.zucchetti:
        return i18n.t('employee_form.payroll_integrations.zucchetti.label')
      case PayrollIntegration.sage100:
        return i18n.t('employee_form.payroll_integrations.sage100.label')
      case PayrollIntegration.teamSystem:
        return i18n.t('employee_form.payroll_integrations.team_system.label')
      case PayrollIntegration.gispaghe:
        return i18n.t('employee_form.payroll_integrations.gispaghe.label')
      case PayrollIntegration.jobSistemi:
        return i18n.t('employee_form.payroll_integrations.job_sistemi.label')
      default:
        return ''
    }
  }

  if (!ManageCodes()) return null

  return (
    <Box paddingBottom="s12">
      {integrationsDescriptor.enabled(installedIntegrations).map((integration, index) => {
        if (!integration.name) return null
        return (
          <Code
            key={index}
            integration={integration.name}
            label={label(integration.name)}
            employee={employee}
            readonly={readonly}
            ref={(el) => (codeRef.current[index] = el)}
            onChange={onChange}
          />
        )
      })}
    </Box>
  )
}

export default Codes
